import { render, staticRenderFns } from "./sub-staff-top.vue?vue&type=template&id=1f0ce8fe&scoped=true"
import script from "./sub-staff-top.vue?vue&type=script&lang=js"
export * from "./sub-staff-top.vue?vue&type=script&lang=js"
import style0 from "./sub-staff-top.vue?vue&type=style&index=0&id=1f0ce8fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0ce8fe",
  null
  
)

export default component.exports